<template>
  <v-container class="py-6">
    <v-responsive max-width="700" class="mx-auto text-center">
      <div class="text-overline secondary--text mb-3">{{ $lang.labels.account }}</div>
      <h2 class="text-h3 text-lg-h2 mb-6">{{ $lang.labels.yourAccount }}</h2>
    </v-responsive>

    <v-card class="pa-4 mx-auto" max-width="600">
      <v-card-text>
        <v-text-field
          v-if="!twoFactorAuth"
          v-model="formData.email"
          label="Email"
          outlined
          data-cy="email"
          @keyup.enter="submit()"
        ></v-text-field>
        <v-text-field
          v-if="!twoFactorAuth"
          v-model="formData.password"
          :append-icon="passwordEye ? 'mdi-eye' : 'mdi-eye-off'"
          :type="passwordEye ? 'text' : 'password'"
          label="Password"
          outlined
          hide-details
          data-cy="password"
          @click:append="passwordEye = !passwordEye"
          @keyup.enter="submit()"
        ></v-text-field>
        <v-text-field
          v-if="twoFactorAuth"
          ref="otpRef"
          v-model="formData.otpCode"
          label="OTP"
          outlined
          data-cy="otp"
          @keyup.enter="submit()"
        ></v-text-field>
        <v-btn
          block
          :class="{ 'accent color-accent-text': true, 'mt-4': !twoFactorAuth }"
          x-large
          :disabled="loadingLogin"
          :loading="loadingLogin"
          data-cy="btn-submit"
          @click="submit()"
        >Sign In</v-btn>
        <div class="text-center mt-2 text-body-2">
          <router-link :to="{ name: 'forgot-password'}">{{ $lang.labels.forgotYourPassword }}</router-link>
        </div>
      </v-card-text>
    </v-card>
    <div class="text-overline text-uppercase mt-3 text-center">
      By signing in, you agree to the
      <a :href="`/${$lang.current_lang}/terms-and-Conditions`" target="_blank">{{ $lang.labels.tos }}</a> & <a :href="`/${$lang.current_lang}/data-protection-policy`" target="_blank">{{ $lang.labels.privacyPolicy }}</a>
    </div>
  </v-container>
</template>
<script>
import auth from '@/auth/index'
import {
  loginUsingPOST as login
} from '@/utils/api'
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      loadingLogin: false,
      formData: {
        email: '',
        password: '',
        otpCode: ''
      },
      twoFactorAuth: false,
      passwordEye: false
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions('app', ['addSnackbar']),

    submit() {
      this.loadingLogin = true
      // Check if email/Password are empty
      if (this.formData.email.length === 0) {
        this.addSnackbar({
          message: this.$lang.errors.missingUsername,
          timeout: 5000,
          color: 'error'
        })
        this.loadingLogin = false

        return
      }
      if (this.formData.password.length === 0) {
        this.addSnackbar({
          message: this.$lang.errors.missingPassword,
          timeout: 5000,
          color: 'error'
        })
        this.loadingLogin = false

        return
      }
      this.formData.email = this.formData.email.toLowerCase().trim()
      if (this.formData.otpCode === '') this.formData.otpCode = null

      // Authenticate user
      login({ body: this.formData })
        .then((res) => {
          if (res?.data?.status === 'SUCCESS') {

            // handle if user has 2FA turned on
            if (res.data.data.twoFactorAuth && !res.data.data.authToken) {
              this.loadingLogin = false
              this.twoFactorAuth = true

              setTimeout(() => {
                this.formData.otpCode = ''
                this.$refs.otpRef.focus()
              }, 100)

              return
            }

            localStorage.userData = JSON.stringify(res.data.data)
            localStorage.savedLocations = '[]'
            auth.userData.loggedInStatus = true
            auth.userData.token = res.data.data.authToken

            if (this.$route.query && this.$route.query.redirect) {
              window.open(this.$route.query.redirect,'_self')
            } else {
              window.open('/','_self')
            }

            return
          }
          this.loadingLogin = false
          const errorMessage = res?.response?.data?.statusText ? res.response.data.statusText : this.$lang.errors.somethingWentWrong

          this.addSnackbar({
            message: errorMessage,
            timeout: 5000,
            color: 'error'
          })
        })
        .catch((err) => {
          console.log(err)
          this.addSnackbar({
            message: this.$lang.errors.somethingWentWrong,
            timeout: 5000,
            color: 'error'
          })
          this.loadingLogin = false
        })

    }
  }
}
</script>
